export const BACK_TO_AUCTION_SALES = 'Back to Auction / Sales';
export const SEARCH_LOT_FIELDS = ['lotNumberWithExtension', 'consignor', 'lotDescription'];
export const NON_RFC_CONNECT_TYPES = ['s', 'i'];
export const CLOSED = 'Closed';
export const LOT_EXTENDED = 'Lot Extended';
export const LOT_CLOSES = 'Lot Closes';
export const ADMIN = 'Admin';
export const INVALUABLE = 'Invaluable';
export const PRIVATE_LABEL = 'Private Label';
export const SUCCESS = 'success';
export const DANGER = 'danger';
export const CHECK_CIRCLE_ICON = 'check-circle';
export const EXCLAMATION_TRIANGLE_ICON = 'exclamation-triangle';
